import './link.less'
import m from 'mithril'
import {classes, Component, action, Icon} from '@codeurs/front'
import Link from './link'

type Mod = 'bigtag' | 'tag' | 'smalltag'

export default class TagLink extends Component<{
	text: string
	class?: string
	mod?: Mod
	[key: string]: any
}> {
	scrollToTop = () => {
		const c = document.documentElement.scrollTop || document.body.scrollTop
		if (c > 0) {
			window.requestAnimationFrame(this.scrollToTop)
			window.scrollTo(0, c - c / 8)
		}
	}

	view() {
		const {class: className, mod, text} = this.attrs
		return m(Link,
			{
				...classes(
					{
						mod
					},
					className,
					'taglink'
				),
				onclick: () => {
					action.navigate('/search?query=' + text)
					this.scrollToTop()
				}
			},
			text
		)
	}
}
